import { gql } from '@apollo/client';
import { AbsenceTypeSourcesFragment } from './absence-type-sources.fragment';
export const UpdateAbsenceSourcesMutation = gql `
    mutation UpdateAbsenceSources(
        $siteSetId: InstitutionSetId!
        $absenceSourceMode: AbsenceSourceMode!
        $holiday: AbsenceTypeSourcesInput
        $sick: AbsenceTypeSourcesInput
        $childSick: AbsenceTypeSourcesInput
        $absent: AbsenceTypeSourcesInput
    ) {
        staffhours {
            settings {
                updateAbsenceSources(
                    siteSetId: $siteSetId
                    absenceSourceMode: $absenceSourceMode
                    holiday: $holiday
                    sick: $sick
                    childSick: $childSick
                    absent: $absent
                ) {
                    absenceSourceMode
                    holiday {
                        ...AbsenceTypeSourcesFragment
                    }
                    sick {
                        ...AbsenceTypeSourcesFragment
                    }
                    childSick {
                        ...AbsenceTypeSourcesFragment
                    }
                    absent {
                        ...AbsenceTypeSourcesFragment
                    }
                }
            }
        }
    }
    ${AbsenceTypeSourcesFragment}
`;
